import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=4d79ff2d&scoped=true&"
import script from "./PlusButton.vue?vue&type=script&lang=ts&"
export * from "./PlusButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlusButton.vue?vue&type=style&index=0&id=4d79ff2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79ff2d",
  null
  
)

export default component.exports